import { ordinal, round } from "@/shared/utils";
import {
  cn,
  Table,
  TableBody,
  TableCaption,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@suns/design-system";
import { percentileClassname } from "../utils";

interface KeySkillsTableProps {
  rimProtection: number | null;
  perimeterDefense: number | null;
  agility: number | null;
  athleticism: number | null;
  print?: boolean;
}

export function KeySkillsTable({
  rimProtection,
  perimeterDefense,
  agility,
  athleticism,
  print = false,
}: KeySkillsTableProps) {
  function value(percentile: number | null) {
    if (!percentile) {
      return "--";
    }
    return `${ordinal(round(percentile))} percentile`;
  }

  const rows = [
    {
      label: "Rim Protection",
      percentile: rimProtection,
      value: value(rimProtection),
    },
    {
      label: "Perimeter D",
      percentile: perimeterDefense,
      value: value(perimeterDefense),
    },
    {
      label: "Agility",
      percentile: agility,
      value: value(agility),
    },
    {
      label: "Athleticism",
      percentile: athleticism,
      value: value(athleticism),
    },
  ];

  return (
    <Table
      className={
        print
          ? cn("[&_td]:p-1", "[&_td]:text-2xs", "[&_th]:p-1", "[&_th]:text-2xs")
          : ""
      }
    >
      <TableHeader>
        <TableRow justify="left">
          {rows.map(({ label }) => (
            <TableHead key={`${label}-head`}>{label}</TableHead>
          ))}
        </TableRow>
      </TableHeader>
      <TableBody className="border">
        <TableRow justify="left">
          {rows.map(({ label, percentile, value }) => {
            const className = percentileClassname(percentile || undefined);
            return (
              <TableCell className={className} key={`${label}-cell`}>
                {value}
              </TableCell>
            );
          })}
        </TableRow>
      </TableBody>
      <TableCaption className={cn("text-left", print ? "text-3xs" : "text-xs")}>
        The table above creates grades for key basketball skills using our
        latest player measurements. Each player is ranked by percentile based on
        current NBA players at the same position. Rim protection is standing
        reach, max vertical jump, and wingspan. Perimeter D is shuttle and
        wingspan. Agility is shuttle, lane, and sprint. Athleticism is max
        vertical, standing vertical, shuttle, lane, and sprint.
      </TableCaption>
    </Table>
  );
}
